<app-search-input
  *ngIf="!asIcon && !asSearchIcon"
  #mainInput
  (inputReset)="mainInputReset()"
  (keydown.enter)="onFocus()"
  (click)="onFocus()"
  [searchAsYouType]="false"
  [mainInput]="true"
  [readonly]="true"
  data-qa="search-main-input-box"
></app-search-input>

<div class="search-wrapper-as-icon-container" *ngIf="asSearchIcon">
  <button
    (click)="onFocus()"
    type="button"
    (pointerdown)="$event.preventDefault()"
    (touchend)="onFocus()"
    class="btn-unstyled search-icon-button"
    data-qa="search-overlay-suggestion-icon"
  >
    <app-svg class="search-icon" iconName="Search"></app-svg>
  </button>
</div>

<div class="search-overlay" *ngIf="searchInputFocus" (click)="closeOnClickOutside($event)">
  <div
    class="search-overlay-container"
    data-qa="search-overlay-container"
    (mousedown)="onSearchWrapperMouseDown()"
  >
    <div class="d-flex input-wrapper search-box-container">
      <div class="d-flex align-items-center justify-content-center mr-md-3">
        <a
          class="close-button"
          role="button"
          (click)="close()"
          data-qa="search-overlay-left-close-arrow"
        >
          <app-svg iconName="chevron-left" dimension="2.5rem"></app-svg>
        </a>
      </div>
      <div class="flex-grow-1">
        <app-search-input
          #suggestionsInput
          (formSubmit)="formSubmit()"
          (inputReset)="suggestionsInputReset()"
          (inputValueChange)="inputValueChanged($event)"
          (inputBlur)="onCloseSearch()"
          [searchAsYouType]="true"
          [autofocus]="true"
          data-qa="search-overlay-input-box"
        ></app-search-input>
      </div>
    </div>
    <div class="search-overlay-content" *ngIf="query">
      <div class="col-12 col-lg-3 py-0 left-column">
        <!-- keyword -->
        <div class="suggestions-results-list" *ngIf="suggestions.keywords.length; else noResults">
          <h4 data-qa="search-overlay-search-suggetion-title">
            {{ 'habaSearch.searchSuggestions' | cxTranslate }}
          </h4>

          <div class="search-suggestion mt-3 mt-lg-6" *ngFor="let keyword of suggestions.keywords">
            <a
              data-qa="search-overlay-suggestion-button"
              role="button"
              (click)="onSuggestionClick(keyword)"
              class="d-flex align-items-center"
            >
              <app-svg
                data-qa="search-overlay-suggestion-icon"
                class="mr-6"
                iconName="Search"
                dimension="1.5rem"
              ></app-svg>
              <span
                class="suggestion-text"
                [innerHtml]="getHightlightedText(keyword.text)"
                data-qa="search-overlay-suggestion-text"
              ></span>
            </a>
          </div>
        </div>
        <!-- category -->
        <ng-container *ngIf="!isMobile()">
          <template *ngTemplateOutlet="category"></template>
          <template *ngTemplateOutlet="brandResults"></template>
        </ng-container>
      </div>
      <div class="col-12 col-lg-9 px-0 py-0">
        <!-- product -->
        <div
          class="products-results-list mt-9 mt-lg-0"
          *ngIf="suggestions.products.length; else noProductResults"
        >
          <h4 data-qa="search-overlay-product-suggestion-text">
            {{ 'habaSearch.productSuggestions' | cxTranslate }}
          </h4>

          <div class="row d-flex">
            <div
              class="col-12 col-lg-4"
              (click)="redirectTo(product)"
              *ngFor="let product of suggestions.products | slice: 0 : 3"
              data-qa="search-overlay-product-card-button"
            >
              <div class="search-suggestion-product-card">
                <div class="product-image">
                  <img
                    [src]="product.imageUrl"
                    [alt]="product.name"
                    width="80"
                    height="80"
                    loading="lazy"
                    data-qa="search-overlay-product-card-image"
                  />
                </div>
                <div class="product-content">
                  <div class="product-text">
                    <div class="product-brand" data-qa="search-overlay-product-card-brand">
                      {{ product.brand }}
                    </div>
                    <div
                      class="product-name"
                      data-qa="search-overlay-product-card-name"
                      [innerHTML]="product.displayText"
                    ></div>
                  </div>
                  <div
                    class="product-price-container"
                    data-qa="search-overlay-product-card-price-container"
                  >
                    <div class="product-price">
                      @if (ociService.showOnlyNetPrices() | async) {
                        <strong data-qa="search-overlay-product-card-price-formatted">
                          {{ product.netPrice | habaCurrency: product.currencyIso }}
                        </strong>
                      } @else {
                        <strong
                          [ngClass]="{
                            'text-red': !!product.strikeThroughPrice,
                            'mr-2': product.strikeThroughPrice,
                          }"
                          data-qa="search-overlay-product-card-price-formatted"
                        >
                          {{ product.price }}
                        </strong>
                        <div
                          class="text-line-through"
                          *ngIf="product.strikeThroughPrice"
                          data-qa="search-overlay-product-card-strikethrough-price"
                        >
                          {{ product.strikeThroughPrice | habaCurrency: product.currencyIso }}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-6" *ngIf="suggestions.products.length > 3">
            <button
              class="btn btn-secondary view-all-products"
              [class.w-100]="isMobile()"
              (click)="onViewMoreClick()"
              data-qa="search-overlay-product-view-all"
            >
              <h4>{{ 'directOrderForm.viewAll' | cxTranslate }}</h4>
            </button>
          </div>
        </div>
        <!-- category -->
        <ng-container *ngIf="isMobile()">
          <template *ngTemplateOutlet="category"></template>
        </ng-container>
        <!-- content pages -->
        <div class="content-pages-description-results-list" *ngIf="suggestions.contentPages.length">
          <div class="mt-9">
            <h4 data-qa="search-overlay-content-pages-suggestion-title">
              {{ 'habaSearch.contentPages' | cxTranslate }}
            </h4>
            <div class="row mt-3 mt-lg-6 search-suggestion-content-container">
              <div
                class="col-12"
                [ngClass]="{
                  'col-12 col-md-6 col-lg-4': suggestions.contentPages.length >= 3,
                  'col-12 col-md-6': suggestions.contentPages.length === 2,
                  'col-12': suggestions.contentPages.length === 1,
                }"
                *ngFor="let page of suggestions.contentPages | slice: 0 : 3; let i = index"
              >
                <div class="search-suggestion-content-card" (click)="redirectTo(page)">
                  <div
                    class="content-image"
                    data-qa="search-overlay-content-pages-suggestion-image"
                  >
                    <app-svg *ngIf="i === 0" iconName="ContentBoard" dimension="2.5rem"></app-svg>
                    <app-svg
                      *ngIf="i === 1"
                      iconName="ContentClassroom"
                      dimension="2.5rem"
                    ></app-svg>
                    <app-svg *ngIf="i === 2" iconName="ContentBlocks" dimension="2.5rem"></app-svg>
                  </div>

                  <div class="content-text">
                    <span
                      class="suggestion-text content-text-description"
                      [innerHtml]="getHightlightedTextFullWord(page.displayText)"
                      data-qa="search-overlay-content-pages-suggestion-text"
                    ></span>
                    <a
                      class="content-text-more"
                      role="button"
                      data-qa="search-overlay-content-pages-suggestion-view-button"
                      >{{ 'habaSearch.more' | cxTranslate }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row d-flex">
          <!-- questions -->
          <div
            class="content-pages-faq-results-list col-12 col-lg-8"
            *ngIf="suggestions.questions.length"
          >
            <div class="mt-9">
              <h4 data-qa="search-overlay-content-pages-faq-suggestion-title">
                {{ 'habaSearch.faq' | cxTranslate }}
              </h4>
              <div
                class="search-suggestion search-suggestion-faq mt-6"
                *ngFor="let question of suggestions.questions"
              >
                <a
                  data-qa="search-overlay-content-pages-faq-suggestion-button"
                  role="button"
                  (click)="redirectTo(question)"
                  class="d-flex align-items-center"
                >
                  <app-svg
                    data-qa="search-overlay-content-pages-faq-suggestion-icon"
                    class="mr-2"
                    iconName="Question"
                    dimension="1.5rem"
                  ></app-svg>
                  <span
                    [innerHtml]="getHightlightedTextFullWord(question.displayText)"
                    data-qa="search-overlay-content-pages-faq-suggestion-text"
                  ></span>
                </a>
              </div>
            </div>
          </div>
          <div *ngIf="isMobile()" class="col-12">
            <template *ngTemplateOutlet="brandResults"></template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noResults>
  <h4 data-qa="search-overlay-search-suggetion-title">
    {{ 'habaSearch.searchSuggestions' | cxTranslate }}
  </h4>

  <div class="no-results-style">{{ 'habaSearch.noSuggestions' | cxTranslate }}</div>
</ng-template>

<ng-template #noProductResults>
  <h4 data-qa="search-overlay-product-suggestion-text">
    {{ 'habaSearch.productSuggestions' | cxTranslate }}
  </h4>
  <div class="no-results-style">{{ 'habaSearch.noProductSuggestions' | cxTranslate }}</div>
</ng-template>

<ng-template #brandResults>
  <!-- <div class="brands-results-list">
    <div *ngIf="showBrands()" class="result-container-style" [class.mt-9]="isMobile()">
      <h4 data-qa="search-overlay-brand-suggestion-title">{{ 'habaSearch.brandSuggestions' | cxTranslate }}</h4>
      <div class="brands-container">
        <div class="search-suggestion search-suggestion-item" *ngFor="let brandSuggestion of brandSuggestions">
          <a
            data-qa="search-overlay-brand-suggestion-button"
            role="button"
            class="d-flex align-items-center"
            (click)="onBrandSuggestionClick(brandSuggestion)"
          >
            <span class="suggestion-text" [innerHtml]="getHightlightedText(brandSuggestion)" data-qa="search-overlay-brand-suggestion-text"></span>
          </a>
        </div>
      </div>
    </div>
  </div> -->
</ng-template>

<ng-template #category>
  <div class="categories-results-list" *ngIf="suggestions.categories.length">
    <div class="result-container-style" [class.mt-9]="isMobile()">
      <h4 data-qa="search-overlay-category-suggestion-title">
        {{ 'habaSearch.categorySuggestions' | cxTranslate }}
      </h4>
      <div class="categories-suggestions-container">
        <div
          class="search-suggestion search-suggestion-item"
          *ngFor="let category of suggestions.categories"
        >
          <a
            data-qa="search-overlay-category-suggestion-button"
            role="button"
            (click)="redirectTo(category)"
            class="d-flex align-items-center"
          >
            <span
              class="suggestion-text"
              [innerHtml]="getHightlightedText(category.displayText)"
              data-qa="search-overlay-category-suggestion-text"
            ></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-template>
